/**
 * 甘特图依赖线组件
 *
 * 使用 SVG 绘制任务之间的依赖关系连线
 */

import * as React from 'react'

interface DependencyLineProps {
  /** 起点坐标 */
  from: { x: number; y: number }
  /** 终点坐标 */
  to: { x: number; y: number }
  /** 是否高亮 */
  isHighlighted: boolean
}

export function DependencyLine({
  from,
  to,
  isHighlighted,
}: DependencyLineProps) {
  // 计算贝塞尔曲线控制点
  // 使用 S 形曲线连接两个任务
  const controlOffset = Math.min(Math.abs(to.x - from.x) / 2, 50)

  // 构建 SVG 路径
  // 从起点水平延伸，然后曲线连接到终点
  const path = React.useMemo(() => {
    // 如果终点在起点左边，使用不同的路径
    if (to.x < from.x) {
      // 向下绕行
      const verticalOffset = 20
      return `
        M ${from.x} ${from.y}
        L ${from.x + 10} ${from.y}
        Q ${from.x + 10 + controlOffset} ${from.y} ${from.x + 10 + controlOffset} ${from.y + verticalOffset}
        L ${from.x + 10 + controlOffset} ${to.y - verticalOffset}
        Q ${from.x + 10 + controlOffset} ${to.y} ${to.x - 10} ${to.y}
        L ${to.x} ${to.y}
      `
    }

    // 正常情况：终点在起点右边
    return `
      M ${from.x} ${from.y}
      C ${from.x + controlOffset} ${from.y}, ${to.x - controlOffset} ${to.y}, ${to.x} ${to.y}
    `
  }, [from, to, controlOffset])

  return (
    <g>
      {/* 连线 */}
      <path
        d={path}
        fill="none"
        stroke={isHighlighted ? 'hsl(var(--primary))' : 'hsl(var(--muted-foreground))'}
        strokeWidth={isHighlighted ? 2 : 1}
        strokeDasharray={isHighlighted ? 'none' : '4 2'}
        opacity={isHighlighted ? 1 : 0.5}
        className="transition-all"
      />

      {/* 箭头 */}
      <polygon
        points={`${to.x},${to.y} ${to.x - 6},${to.y - 4} ${to.x - 6},${to.y + 4}`}
        fill={isHighlighted ? 'hsl(var(--primary))' : 'hsl(var(--muted-foreground))'}
        opacity={isHighlighted ? 1 : 0.5}
        className="transition-all"
      />
    </g>
  )
}
